export interface ITimestampInfos {
    chiamataPreAdesioneDateTime: Date;
}

export class TimestampInfos implements ITimestampInfos{
    chiamataPreAdesioneDateTime: Date;
    constructor(tsi: ITimestampInfos) {
        if (tsi == null) {
            tsi = {} as ITimestampInfos;
        }
        this.chiamataPreAdesioneDateTime = tsi.chiamataPreAdesioneDateTime != null ? new Date(tsi.chiamataPreAdesioneDateTime) : null;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/timestampInfos.ts